module.exports = __webpack_public_path__ + "img/bitcoin-cash.f959530a.png";